const defaultState = {
  organizations: [],
  user: undefined,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_ACCOUNT_USER':
      return { ...state, user: action.user };
    case 'SET_ACCOUNT_ORGANIZATION':
      return { ...state, organizations: action.organizations };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/account.js